import React from "react";
import styled from "styled-components/macro";
import { defaultTheme } from "../../theme/defaultTheme";

export interface IButtonProps {
  size: "large" | "medium" | "small";
  buttonType: "primary" | "primaryBlack" | "secondary";
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  disabled?: boolean;
  children?: React.ReactNode;
  isLoading?: boolean;
  hasError?: boolean;
  textTrKey: string;
}
const defaultProps: IButtonProps = {
  textTrKey: "",
  size: "large",
  buttonType: "primary"
};

export const Button: React.FC<Partial<IButtonProps>> = props => (
  <StyledButton {...defaultProps} {...props} type="button" />
);

const StyledButton = styled.button<IButtonProps>`
  text-decoration: none;
  cursor: pointer;
  box-sizing: border-box;

  display: flex;
  justify-content: center;
  align-items: center;

  min-width: 128px;
  max-width: 400px;
  height: ${({ size }) => config.height[size]};
  padding-left: ${({ size }) => config.padding[size]};
  padding-right: ${({ size }) => config.padding[size]};

  font-size: ${({ size }) => config.fontSize[size]};
  font-weight: 700;
  line-height: 20px;
  text-align: center;

  color: ${({ buttonType }) => config.color.default[buttonType]};
  background-color: ${({ buttonType }) => config.backgroundColor.default[buttonType]};
  border: 2px solid ${({ buttonType }) => config.borderColor.default[buttonType]};

  &:hover {
    color: ${({ buttonType }) => config.color.hover[buttonType]};
    background-color: ${({ buttonType }) => config.backgroundColor.hover[buttonType]};
    border: 2px solid ${({ buttonType }) => config.borderColor.hover[buttonType]};
  }

  &:disabled {
    cursor: initial;
    color: ${({ buttonType }) => config.color.disabled[buttonType]};
    background-color: ${({ buttonType }) => config.backgroundColor.disabled[buttonType]};
    border: 2px solid ${({ buttonType }) => config.borderColor.disabled[buttonType]};
  }

  &:active:not(:disabled) {
    transform: translateY(1px);
  }
`;

const { newColors } = defaultTheme;

const config = {
  height: {
    large: "52px",
    medium: "44px",
    small: "28px"
  },
  padding: {
    large: "32px",
    medium: "32px",
    small: "24px"
  },
  fontSize: {
    large: "16px",
    medium: "16px",
    small: "14px"
  },
  color: {
    default: {
      primary: newColors.white,
      primaryBlack: newColors.white,
      secondary: newColors.grayDark
    },
    hover: {
      primary: newColors.white,
      primaryBlack: newColors.white,
      secondary: newColors.primary100
    },
    disabled: {
      primary: newColors.white,
      primaryBlack: newColors.gray05,
      secondary: newColors.gray60
    }
  },
  backgroundColor: {
    default: {
      primaryBlack: newColors.grayDark,
      primary: newColors.primary100,
      secondary: newColors.white
    },
    hover: {
      primary: newColors.grayDark,
      primaryBlack: newColors.primary100,
      secondary: newColors.white
    },
    disabled: {
      primary: newColors.inactive,
      primaryBlack: newColors.gray60,
      secondary: newColors.gray10
    }
  },
  borderColor: {
    default: {
      primary: newColors.primary100,
      primaryBlack: newColors.grayDark,
      secondary: newColors.gray30
    },
    hover: {
      primary: newColors.grayDark,
      primaryBlack: newColors.primary100,
      secondary: newColors.primary100
    },
    disabled: {
      primary: newColors.inactive,
      primaryBlack: newColors.gray60,
      secondary: newColors.gray30
    }
  }
};
